import { useReducer } from 'react';
import showFilterStore, {
  INITIAL_SHOW_FILTER,
} from '../store/showFilter/showFilterStore';
import {
  ShowFilterStoreKind,
  ShowFilterStoreType,
} from 'src/store/showFilter/showFilterStore.types';

export interface ShowFilterHook {
  state: ShowFilterStoreType;
  actions: { setShowFilter: (showFilter: boolean) => void };
}

const useShowFilterHook = (): ShowFilterHook => {
  const [state, dispatch] = useReducer(showFilterStore, INITIAL_SHOW_FILTER);

  const setShowFilter = (showFilter: boolean): void => {
    dispatch({
      type: ShowFilterStoreKind.INITIAL,
      payload: { showFilter },
    });
  };
  return { state, actions: { setShowFilter } };
};

export default useShowFilterHook;
